import React, { useState } from "react"
import { Col, Container, Row } from "react-bootstrap"
import { injectIntl } from "gatsby-plugin-intl"

import FsLightbox from "fslightbox-react"
import { MobileButton } from "@/components/shared/button/button"

import img1 from "@/images/z-26/ojp3-katalog/WillBud-folder-OJPIII-WWW_pages-to-jpg-0001.jpg"
import img2 from "@/images/z-26/ojp3-katalog/WillBud-folder-OJPIII-WWW_pages-to-jpg-0002.jpg"
import img3 from "@/images/z-26/ojp3-katalog/WillBud-folder-OJPIII-WWW_pages-to-jpg-0003.jpg"
import img4 from "@/images/z-26/ojp3-katalog/WillBud-folder-OJPIII-WWW_pages-to-jpg-0004.jpg"
import img5 from "@/images/z-26/ojp3-katalog/WillBud-folder-OJPIII-WWW_pages-to-jpg-0005.jpg"
import img6 from "@/images/z-26/ojp3-katalog/WillBud-folder-OJPIII-WWW_pages-to-jpg-0006.jpg"
import img7 from "@/images/z-26/ojp3-katalog/WillBud-folder-OJPIII-WWW_pages-to-jpg-0007.jpg"
import img8 from "@/images/z-26/ojp3-katalog/WillBud-folder-OJPIII-WWW_pages-to-jpg-0008.jpg"
import img9 from "@/images/z-26/ojp3-katalog/WillBud-folder-OJPIII-WWW_pages-to-jpg-0009.jpg"
import img10 from "@/images/z-26/ojp3-katalog/WillBud-folder-OJPIII-WWW_pages-to-jpg-0010.jpg"
import img11 from "@/images/z-26/ojp3-katalog/WillBud-folder-OJPIII-WWW_pages-to-jpg-0011.jpg"
import img12 from "@/images/z-26/ojp3-katalog/WillBud-folder-OJPIII-WWW_pages-to-jpg-0012.jpg"
import img13 from "@/images/z-26/ojp3-katalog/WillBud-folder-OJPIII-WWW_pages-to-jpg-0013.jpg"
import img14 from "@/images/z-26/ojp3-katalog/WillBud-folder-OJPIII-WWW_pages-to-jpg-0014.jpg"
import img15 from "@/images/z-26/ojp3-katalog/WillBud-folder-OJPIII-WWW_pages-to-jpg-0015.jpg"
import img16 from "@/images/z-26/ojp3-katalog/WillBud-folder-OJPIII-WWW_pages-to-jpg-0016.jpg"
import img17 from "@/images/z-26/ojp3-katalog/WillBud-folder-OJPIII-WWW_pages-to-jpg-0017.jpg"
import img18 from "@/images/z-26/ojp3-katalog/WillBud-folder-OJPIII-WWW_pages-to-jpg-0018.jpg"
import img19 from "@/images/z-26/ojp3-katalog/WillBud-folder-OJPIII-WWW_pages-to-jpg-0019.jpg"
import img20 from "@/images/z-26/ojp3-katalog/WillBud-folder-OJPIII-WWW_pages-to-jpg-0020.jpg"

const OJP3Catalog = ({ intl }) => {
  const [lightboxController, setLightboxController] = useState({
    toggler: false,
    slide: 1,
  })

  const slides = [img1, img2, img3, img4, img5, img6, img7, img8, img9, img10, img11, img12, img13, img14, img15, img16, img17, img18, img19, img20,]

  return (
    <div>
      <Container className="no-padding">
        <Row>
          <Col xs="12" sm={7} md={5} style={{ margin: "64px auto" }}>
            <MobileButton
              handleAction={() => {
                setLightboxController({
                  slide: 1,
                  toggler: !lightboxController.toggler,
                })
              }}
              bg="#fff"
              border="#94C835"
              color="#94C835"
              arrow={false}
              smallArrow={false}
              height={"auto"}
              style={{padding: 0}}
            >
              <img
                src={img1}
                alt={"Katalog Osiedle Janowo Park III"}
                width="100%"
                height={400}
                style={{ maxWidth: "100%", height: "auto" }}
              />
              <p>Katalog Osiedle Janowo Park III (online)</p>
            </MobileButton>
            <div className="text-center">
              <a
                href="/assets/files/ojp3/WillBud-folder-OJPIII-WWW.pdf"
                target="_blank"
                style={{
                  color: "black",
                  display: "inline-block",
                  margin: "15px auto",
                }}
              >
                Katalog Osiedle Janowo Park III (PDF)
              </a>
            </div>
          </Col>
        </Row>
      </Container>

      <FsLightbox
        toggler={lightboxController.toggler}
        sources={slides}
        slide={lightboxController.slide}
      />
    </div>
  )
}

export default injectIntl(OJP3Catalog)
